import { NotificationManager } from "react-notifications";

export function handleSaveSuccess() {
    const { saveVmProviderError, savedVmProvider } = this.props;
    if (saveVmProviderError) {
        NotificationManager.error(saveVmProviderError, "Save VM Provider Config", 3000);
        return null
    }
    else {
        NotificationManager.success("VM Provider Config Saved", "Successfully Saved VM Provider Config");
        if (this.props.inline || this.props.wizard || this.state.wizard) {
            this.setState({ vm_provider_config: savedVmProvider })
            this.nextPage() 
        } else {
            this.props.history.push("/vm_provider");
        }
    }
}

export function handleSaveError() {
    const { saveVmProviderError } = this.props;
    if (saveVmProviderError) {
        NotificationManager.error(saveVmProviderError, "Save VM Provider Config", 3000);
    } else
        NotificationManager.error("Save VM Provider Config Failed", "Save VM Provider Config", 3000);
}
